import styled from 'styled-components';
import Grid from 'src/components/Grid';

export const StyledContainer = styled((props) => <Grid {...props} />)`
  justify-content: space-between;
`;
